import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getGameOverState, gameOverScenarios } from '../store/selectors/getGameOverState';
import GameOver from '../GameOver';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import gameOverReducer from '../store/reducers/gameOver';
import ruleSettingsDatasource from '@gameday/core/datasources/ruleSettings';
import scheduleDataSource from '@gameday/core/datasources/schedule';
import gameOverDataRequestAction from '../store/actions/gameOverDataRequestAction';
import { routes as teamSummaryRoutes } from '../../TeamSummaryMatchup/TeamSummaryMatchupDataContainer';

const fetchData = () => {
    return gameOverDataRequestAction();
};

initContainerData.register({
    datasources: {
        ruleSettings: ruleSettingsDatasource,
        schedule: scheduleDataSource
    },
    reducers: {
        gameOver: gameOverReducer
    }
});

const routes = [{
    path: '/',
    exact: false,
    fetchData,
    routes: [...teamSummaryRoutes]
}];

const {
    ACTIVE_TIEBREAKER
} = gameOverScenarios;
const GameOverDataContainer = (props) => {
    const gameOverState = useSelector(getGameOverState);
    const {
        abstractGameCode = '',
        gameOverScenario : {
            scenario
        }
    } = gameOverState;
    return (
        abstractGameCode === 'F' || scenario === ACTIVE_TIEBREAKER ? <GameOver
            { ...gameOverState }
            { ...props }
        /> : null
    );
};

GameOverDataContainer.propTypes = {
    wrapButtonHandler: PropTypes.func
};

export default GameOverDataContainer;

export { fetchData, routes };
